import React, { useEffect, useState } from 'react';
import Loader from 'features/Loader/Loader';
import ClientSearch from 'features/home/components/client/ClientSearch';
import ClientSideHead from './ClientSideHead';
import ClientSideList from './ClientSideList';

const ClientSide = ({ setActiveChat, activeChat, chats, unreadCount }) => {
  const [searchInput, setSearch] = useState('');
  const [viewedChats, setViewedChats] = useState(null);
  const [filteredChats, setFilteredChats] = useState(null);

  useEffect(() => {
    chats && setViewedChats(chats.filter(chat => chat.channel.lastMessage));
  }, [chats]);

  useEffect(() => {
    viewedChats &&
      setFilteredChats(
        viewedChats.filter(chat =>
          `${chat.client.first_name.toLowerCase()} ${chat.client.last_name.toLowerCase()}`.includes(
            searchInput.toLowerCase()
          )
        )
      );
  }, [searchInput, viewedChats]);

  return (
    <div className="client-side">
      <ClientSideHead
        label={`Messages ${unreadCount > 0 ? `(${unreadCount})` : ''}`}
        btnTxt="Add"
        url="/messages/new"
      />
      <ClientSearch setInput={setSearch} />
      {filteredChats ? (
        filteredChats.length ? (
          <ClientSideList
            setActiveChat={setActiveChat}
            activeChat={activeChat}
            filteredChats={filteredChats}
          />
        ) : (
          <p style={{ margin: '30%' }}>No Channels Found</p>
        )
      ) : (
        <Loader />
      )}
    </div>
  );
};

export default ClientSide;
